function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var BasePlugin = require('@uppy/core/lib/BasePlugin');

var findDOMElement = require('@uppy/utils/lib/findDOMElement');

var toArray = require('@uppy/utils/lib/toArray'); // Rollup uses get-form-data's ES modules build, and rollup-plugin-commonjs automatically resolves `.default`.
// So, if we are being built using rollup, this require() won't have a `.default` property.


var getFormData = require('get-form-data').default || require('get-form-data');
/**
 * Form
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Form, _BasePlugin);

  var _super = _createSuper(Form);

  function Form(uppy, opts) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, uppy, opts);
    _this.type = 'acquirer';
    _this.id = _this.opts.id || 'Form';
    _this.title = 'Form'; // set default options

    var defaultOptions = {
      target: null,
      resultName: 'uppyResult',
      getMetaFromForm: true,
      addResultToForm: true,
      submitOnSuccess: false,
      triggerUploadOnSubmit: false
    }; // merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_assertThisInitialized(_this));
    _this.handleUploadStart = _this.handleUploadStart.bind(_assertThisInitialized(_this));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_this));
    _this.addResultToForm = _this.addResultToForm.bind(_assertThisInitialized(_this));
    _this.getMetaFromForm = _this.getMetaFromForm.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Form, [{
    key: "handleUploadStart",
    value: function handleUploadStart() {
      if (this.opts.getMetaFromForm) {
        this.getMetaFromForm();
      }
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(result) {
      if (this.opts.addResultToForm) {
        this.addResultToForm(result);
      }

      if (this.opts.submitOnSuccess) {
        this.form.submit();
      }
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit(ev) {
      var _this2 = this;

      if (this.opts.triggerUploadOnSubmit) {
        ev.preventDefault();
        var elements = toArray(ev.target.elements);
        var disabledByUppy = [];
        elements.forEach(function (el) {
          var isButton = el.tagName === 'BUTTON' || el.tagName === 'INPUT' && el.type === 'submit';

          if (isButton && !el.disabled) {
            el.disabled = true;
            disabledByUppy.push(el);
          }
        });
        this.uppy.upload().then(function () {
          disabledByUppy.forEach(function (button) {
            button.disabled = false;
          });
        }, function (err) {
          disabledByUppy.forEach(function (button) {
            button.disabled = false;
          });
          return Promise.reject(err);
        }).catch(function (err) {
          _this2.uppy.log(err.stack || err.message || err);
        });
      }
    }
  }, {
    key: "addResultToForm",
    value: function addResultToForm(result) {
      this.uppy.log('[Form] Adding result to the original form:');
      this.uppy.log(result);
      var resultInput = this.form.querySelector("[name=\"".concat(this.opts.resultName, "\"]"));

      if (resultInput) {
        // Append new result to the previous result array.
        // If the previous result is empty, or not an array,
        // set it to an empty array.
        var updatedResult;

        try {
          updatedResult = JSON.parse(resultInput.value);
        } catch (err) {// Nothing, since we check for array below anyway
        }

        if (!Array.isArray(updatedResult)) {
          updatedResult = [];
        }

        updatedResult.push(result);
        resultInput.value = JSON.stringify(updatedResult);
        return;
      }

      resultInput = document.createElement('input');
      resultInput.name = this.opts.resultName;
      resultInput.type = 'hidden';
      resultInput.value = JSON.stringify([result]);
      this.form.appendChild(resultInput);
    }
  }, {
    key: "getMetaFromForm",
    value: function getMetaFromForm() {
      var formMeta = getFormData(this.form); // We want to exclude meta the the Form plugin itself has added
      // See https://github.com/transloadit/uppy/issues/1637

      delete formMeta[this.opts.resultName];
      this.uppy.setMeta(formMeta);
    }
  }, {
    key: "install",
    value: function install() {
      this.form = findDOMElement(this.opts.target);

      if (!this.form || this.form.nodeName !== 'FORM') {
        this.uppy.log('Form plugin requires a <form> target element passed in options to operate, none was found', 'error');
        return;
      }

      this.form.addEventListener('submit', this.handleFormSubmit);
      this.uppy.on('upload', this.handleUploadStart);
      this.uppy.on('complete', this.handleSuccess);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.form.removeEventListener('submit', this.handleFormSubmit);
      this.uppy.off('upload', this.handleUploadStart);
      this.uppy.off('complete', this.handleSuccess);
    }
  }]);

  return Form;
}(BasePlugin), _class.VERSION = "2.0.4", _temp);